import React, { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Button, DatePicker, Popconfirm, Tooltip } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import TrashIcon from "../../../Img/trash.svg";
import {
  complicationOptions,
  embryoGradeOptions,
  etProvider,
  etStatusOptions,
  fertCheckOptions,
  gobletColorOptions,
  oocytesQualityOptions,
  stageOfDevOptions,
  statusOptions,
  strawColorOptions,
  vitrificationIdOptions,
} from "utils/FieldValues";
import {
  days,
  checkD5FairValues,
  checkD5GoodValues,
  checkD5PoorValues,
  checkD6FairValues,
  checkD6GoodValues,
  checkD6PoorValues,
  checkD7FairValues,
  checkD7GoodValues,
  checkD7PoorValues,
  assignEDSTableEmptyValueFields,
  disabledFields,
  getClassNameForValue,
} from "./Constant";
import { useLocation } from "react-router-dom";
import { setEmbryologyDetails } from "redux/reducers/EmbryologyData/embryologyData.slice";
import CustomCreatableSelect from "utils/CustomCreatableSelect";
import { Stack } from "react-bootstrap";
import { InfoCircleOutlined } from "@ant-design/icons";

export const EmbryologyOocyteTrackingTable = (props) => {
  const {
    i,
    embryoRow,
    tableData,
    setFieldValue,
    values,
    userType,
    moduleList,
    embryologyData,
    IvfFlowsheetList,
    selectedLocation,
    embryologyDetails,
  } = props;

  const location = useLocation();

  const check_FreshET_in_planned_cycle = useMemo(() => {
    return IvfFlowsheetList?.planned_cycle?.includes("Fresh ET");
  }, [IvfFlowsheetList?.planned_cycle]);

  const check_FreshET_status_in_embryo = useMemo(() => {
    return tableData?.[i]?.embryo?.some(
      (item) => item.et_status?.value === "Fresh ET"
    );
  }, [tableData]);

  const check_OTHER_provider_in_embryo = useMemo(() => {
    return tableData?.[i]?.embryo?.some(
      (item) => item.provider?.value === "OTHER"
    );
  }, [tableData]);

  const check_OTHER_introducer_in_embryo = useMemo(() => {
    return tableData?.[i]?.embryo?.some(
      (item) => item.introducer?.value === "OTHER"
    );
  }, [tableData]);

  const check_OTHER_straw_color_in_embryo = useMemo(() => {
    return tableData?.[i]?.embryo?.some(
      (item) => item.straw_color?.value === "Other"
    );
  }, [tableData]);

  const check_OTHER_goblet_color_in_embryo = useMemo(() => {
    return tableData?.[i]?.embryo?.some(
      (item) => item.goblet_color?.value === "Other"
    );
  }, [tableData]);

  const check_embryo_dev_pgt_in_embryo = useMemo(() => {
    return values?.embryo_dev_pgt !== "NO";
  }, [values?.embryo_dev_pgt]);

  const check_embryo_dev_incubator_in_embryo = useMemo(() => {
    return values?.embryo_dev_incubator === "TIME-LAPSE";
  }, [values?.embryo_dev_incubator]);

  const renderTable = useMemo(() => {
    return (
      <table className="custom-table">
        <thead style={{ color: "#808080" }}>
          <tr>
            <div className="sticky_row">
              <th className="w_150">Oocytes</th>
              <th className="w_200">Maturation Stage</th>
            </div>
            <th className="w_250">Oocyte Quality</th>
            <th className="w_200">Fert Check</th>
            <th className="w_200">Stage of development</th>
            <th className="w_170">Embryo Grade</th>
            <th className="w_170">Blasto Score</th>
            <th className="w_90">Rating</th>
            {check_FreshET_in_planned_cycle ? (
              <th className="w_170">ET Status</th>
            ) : null}
            {check_FreshET_status_in_embryo ? (
              <th className="w_170">Provider</th>
            ) : null}
            {check_OTHER_provider_in_embryo ? (
              <th className="w_170">Provider Other </th>
            ) : null}
            {check_FreshET_status_in_embryo ? (
              <th className="w_170">Introducer</th>
            ) : null}
            {check_OTHER_introducer_in_embryo ? (
              <th className="w_170">Introducer Other </th>
            ) : null}
            {check_FreshET_status_in_embryo ? (
              <th className="w_170">Complication</th>
            ) : null}

            <th className="w_170">Date of freezing</th>

            <th className="w_250">
              Vitrification ID
              {"(Straw ID)"}
            </th>
            <th className="w_190">Color of Straw</th>

            {check_OTHER_straw_color_in_embryo ? (
              <th className="w_200">Color of Straw Other</th>
            ) : null}

            <th className="w_170">Color of Goblet</th>

            {check_OTHER_goblet_color_in_embryo ? (
              <th className="w_200">Color of Goblet Other</th>
            ) : null}
            <th className="w_150">Vitrified by</th>
            {check_embryo_dev_pgt_in_embryo ? (
              <th className="w_120">Status</th>
            ) : null}
            {check_embryo_dev_incubator_in_embryo ? (
              <th className="w_170">Well No.</th>
            ) : null}
            <th className="w_170">Action</th>
          </tr>
        </thead>
        <tbody>
          {embryoRow?.embryo?.map((item, index) => {
            return (
              <EmbryoListItemContainer
                key={index}
                i={i}
                item={item}
                index={index}
                values={values}
                tableData={tableData}
                setFieldValue={setFieldValue}
                location={location}
                moduleList={moduleList}
                embryologyDetails={embryologyDetails}
                embryologyData={embryologyData}
                selectedLocation={selectedLocation}
                userType={userType}
                check_FreshET_in_planned_cycle={check_FreshET_in_planned_cycle}
                check_FreshET_status_in_embryo={check_FreshET_status_in_embryo}
                check_OTHER_provider_in_embryo={check_OTHER_provider_in_embryo}
                check_OTHER_introducer_in_embryo={
                  check_OTHER_introducer_in_embryo
                }
                check_OTHER_straw_color_in_embryo={
                  check_OTHER_straw_color_in_embryo
                }
                check_OTHER_goblet_color_in_embryo={
                  check_OTHER_goblet_color_in_embryo
                }
                check_embryo_dev_pgt_in_embryo={check_embryo_dev_pgt_in_embryo}
                check_embryo_dev_incubator_in_embryo={
                  check_embryo_dev_incubator_in_embryo
                }
              />
            );
          })}
        </tbody>
      </table>
    );
  }, [
    i,
    tableData,
    setFieldValue,
    userType,
    location,
    moduleList,
    embryologyData,
    selectedLocation,
    embryoRow.embryo,
    embryologyDetails,
    check_FreshET_in_planned_cycle,
    check_FreshET_status_in_embryo,
    check_OTHER_provider_in_embryo,
    check_embryo_dev_pgt_in_embryo,
    check_OTHER_introducer_in_embryo,
    check_OTHER_straw_color_in_embryo,
    check_OTHER_goblet_color_in_embryo,
    check_embryo_dev_incubator_in_embryo,
  ]);

  return (
    <div className="inner_table_wrapper respnsive_table_width">
      {renderTable}
    </div>
  );
};

const EmbryoListItemContainer = ({
  i,
  item,
  index,
  values,
  tableData,
  setFieldValue,
  location,
  userType,
  moduleList,
  embryologyData,
  selectedLocation,
  embryologyDetails,
  check_FreshET_in_planned_cycle,
  check_FreshET_status_in_embryo,
  check_embryo_dev_pgt_in_embryo,
  check_OTHER_provider_in_embryo,
  check_OTHER_introducer_in_embryo,
  check_OTHER_straw_color_in_embryo,
  check_OTHER_goblet_color_in_embryo,
  check_embryo_dev_incubator_in_embryo,
}) => {
  const dispatch = useDispatch();

  let loggedUserData = localStorage.getItem("UserPreferences");

  if (loggedUserData) {
    loggedUserData = JSON.parse(window.atob(loggedUserData));
  }

  const disabledField = useCallback(
    (key, rowData, mainIndex, innerIndex) => {
      // const formValue = form.getFieldsValue();

      const cycleType = embryologyDetails?.cycle_type || "";
      // const formValue = { ...item };
      const formValue = { ...rowData };

      if (cycleType) {
        const shouldDisableByMap = disabledFields[key]?.some((type) =>
          type === "FET+Surrogacy"
            ? cycleType.includes("FET") && cycleType.includes("Surrogacy")
            : cycleType.includes(type)
        );

        if (shouldDisableByMap) return true;
      }

      if (key === "blasto_score") {
        // const checkFertValues = ["Degenerated", "Unfert", "Lysed"].includes(
        //   formValue[`fert_check${mainIndex}${innerIndex}`]
        // );

        const checkFertValues = ["Degenerated", "Unfert", "Lysed"].includes(
          formValue?.fert_check?.value
        );

        // const checkStageDevelopmentValue =
        //   tableData[mainIndex]?.embryo[innerIndex]?.stage_of_development
        //     ?.value === "D3";

        const checkStageDevelopmentValue =
          formValue?.stage_of_development?.value === "D3";

        // const checkCycleType = cycleType.includes("Oocytes Vitrification");

        // return checkCycleType || checkFertValues || checkStageDevelopmentValue;
        return checkFertValues || checkStageDevelopmentValue;
      }

      if (key === "vitrification_id") {
        const embryoItemId = formValue?._id;

        const findLocationData = loggedUserData?.userLocationData?.find(
          (item) => item?.location_id === selectedLocation
        );

        const hasThirdAndForthUserType = ![1, 2].includes(
          findLocationData?.user_type
        );

        const alreadyHasVitrificationId =
          Object.keys(tableData).length > 0 &&
          tableData.some((count) =>
            count.embryo.some(
              (emb) =>
                emb._id === embryoItemId &&
                hasThirdAndForthUserType &&
                emb?.hasVitrificationId
            )
          );

        // if (cycleType.includes("Oocytes Vitrification")) return true;

        return alreadyHasVitrificationId && findLocationData;
      }

      return false;
    },
    [
      tableData,
      selectedLocation,
      embryologyDetails?.cycle_type,
      loggedUserData?.userLocationData,
    ]
  );

  const selectedModule = useMemo(() => {
    return (
      moduleList?.find((item) => item?.module_name === location?.pathname) || {}
    );
  }, [moduleList]);

  const formattedTooltipOutput = (embryoHistory) =>
    embryoHistory?.length &&
    embryoHistory?.map((entry, index) => (
      <div key={index}>{`${entry?.stage} => ${entry?.grade}`}</div>
    ));

  const handleBlastoScore = (
    blastoScoreValue,
    checkGoodValue,
    checkFairValue,
    checkPoorValue
  ) => {
    let rate = "";

    if (checkGoodValue.includes(blastoScoreValue)) {
      rate = "Good";
    } else if (checkFairValue.includes(blastoScoreValue)) {
      rate = "Fair";
    } else if (
      checkPoorValue.includes(blastoScoreValue) ||
      (blastoScoreValue?.length === 3 && blastoScoreValue?.includes("D"))
    ) {
      rate = "Poor";
    } else {
      rate = "";
    }
    return rate;
  };

  const convertToCommonDateFormat = (dateString) => {
    const possibleFormats = [
      "DD/MM/YYYY",
      "MM/DD/YYYY",
      "YYYY-MM-DD",
      "DD-MM-YYYY",
      "MM-DD-YYYY",
      "YYYY/MM/DD",
      moment.ISO_8601, // For ISO formatted dates
    ];

    const parsedDate = moment(dateString, possibleFormats, true); // 'true' for strict parsing
    if (!parsedDate.isValid()) {
      return null;
    }

    return parsedDate.format("YYYY-MM-DD");
  };

  const handleEmbryoChange = useCallback(
    (
      // patientIndex, embryoIndex, fieldName, value
      mainIndex,
      innerIndex,
      key,
      value
    ) => {
      // et_status

      const updatedRow = { ...tableData[mainIndex] };
      const updatedEmbryo = [...updatedRow.embryo];
      const updatedEmbryoItem = { ...updatedEmbryo[innerIndex], [key]: value };
      updatedEmbryo[innerIndex] = updatedEmbryoItem;

      let fert = 0;
      let cleaved = 0;
      let unfert = 0;
      let degenerated = 0;
      let total_blastocyst = 0;
      let countD3 = 0;
      let grade = "";
      // let uniqueVitrificationIds = new Set();
      // updatedEmbryo[innerIndex][key] = value;

      if (key === "goblet_color" && innerIndex === 0) {
        const firstRowColor = value;

        updatedEmbryo.forEach((item) => {
          if (item["date_of_freezing"] && item["vitrification_id"]) {
            item["goblet_color"] = firstRowColor;
          }
        });
      }

      // Clear specific fields if embryo_grade is D3 Arrested, Lysed or NA
      if (key === "embryo_grade" && value?.value) {
        const embryoGradeValue = ["D3 Arrested", "Lysed", "NA"];
        if (embryoGradeValue.includes(value.value)) {
          updatedEmbryo[innerIndex] = {
            ...updatedEmbryo[innerIndex],
            blasto_score: "",
            rating: "",
            date_of_freezing: "",
            vitrification_id: "",
            straw_color: "",
            goblet_color: "",
            vitrified_by: [],
            status: "",
          };
        }
      }

      updatedEmbryo.forEach((item) => {
        // General handling for the value update
        // item[key] = item[key] === undefined ? value : item[key];
        // if (item[key] === undefined) {
        //   item[key] = value
        // }

        // Fertility Check Logic
        const fertCheck = item?.fert_check?.value;

        if (["1PN", "2PN", "3PN", "2 Cell"].includes(fertCheck)) fert++;
        else if (fertCheck === "Unfert") unfert++;
        else if (fertCheck === "Degenerated") degenerated++;
        // switch (item?.fert_check?.value) {
        //   case "1PN":
        //   case "2PN":
        //   case "3PN":
        //   case "2 Cell":
        //     fert++;
        //     break;
        //   case "Unfert":
        //     unfert++;
        //     break;
        //   case "Degenerated":
        //     degenerated++;
        //     break;
        //   default:
        //     break;
        // }

        // Cleaved Logic (Embryo Grade)
        const embryoGrade = item?.embryo_grade?.value;
        if (
          ["Grade-I", "Grade-II", "Grade-III", "D3 Arrested"].includes(
            embryoGrade
          )
        ) {
          cleaved++;
        }
        // switch (item?.embryo_grade?.value) {
        //   case "Grade-I":
        //   case "Grade-II":
        //   case "Grade-III":
        //     cleaved++;
        //     break;
        //   case "D3 Arrested":
        //     // updatedEmbryo[innerIndex]["date_of_freezing"] = null;
        //     cleaved++;
        //     break;
        //   case "Lysed":
        //     // updatedEmbryo[innerIndex]["date_of_freezing"] = null;
        //     break;
        //   default:
        //     break;
        // }

        // updatedRow.cleaved = cleaved;

        // Vitrification ID and Freezing Date Logic
        // if (item?.vitrification_id) {
        //   uniqueVitrificationIds.add(item?.vitrification_id);
        // }

        // if (key === "date_of_freezing") {
        //   obj[`date_of_freezing${mainIndex}${innerIndex}`] = value
        //     ? dayjs(moment(value).format("DD/MM/YYYY"), "DD/MM/YYYY")
        //     : null;
        // }

        // Blastocyst Score Logic
        if (item?.blasto_score) {
          total_blastocyst++;
        }

        if (key === "blasto_score" && value) {
          //   const formValues = form.getFieldsValue();
          // const stage =
          // formValues[`stage_of_development${mainIndex}${innerIndex}`];

          const stage = updatedEmbryoItem?.stage_of_development?.value;

          if (stage) {
            const handleScore = {
              D5: handleBlastoScore(
                value,
                checkD5GoodValues,
                checkD5FairValues,
                checkD5PoorValues
              ),
              D6: handleBlastoScore(
                value,
                checkD6GoodValues,
                checkD6FairValues,
                checkD6PoorValues
              ),
              D7: handleBlastoScore(
                value,
                checkD7GoodValues,
                checkD7FairValues,
                checkD7PoorValues
              ),
            };
            grade = handleScore[stage] || "";
            updatedEmbryo[innerIndex]["rating"] = grade;
          }
          // updatedEmbryo[innerIndex]["rating"] = grade;
        }

        // Stage of Development Logic (Freezing Date & Rating) : This logic purpose for Kept-for-blastocyst
        if (key === "stage_of_development") {
          //   obj[`date_of_freezing${mainIndex}${innerIndex}`] = null;

          //   obj[`rating${mainIndex}${innerIndex}`] = null;
          //   obj[`blasto_score${mainIndex}${innerIndex}`] = null;

          let day = days[value?.value];
          const gradeVal = updatedEmbryo[innerIndex]?.embryo_grade?.value;

          if (["D3 Arrested", "Lysed"].includes(gradeVal)) {
            updatedEmbryo[innerIndex]["date_of_freezing"] = null;
          } else {
            if (day) {
              //   obj[`date_of_freezing${mainIndex}${innerIndex}`] =
              //     embryologyDetails?.day_0_date
              //       ? dayjs(
              //           moment(embryologyDetails?.day_0_date)
              //             .add(day, "days")
              //             .format("DD/MM/YYYY"),
              //           "DD/MM/YYYY"
              //         )
              //       : null;
              const date = values?.day_0_date
                ? moment(values?.day_0_date)
                    .add(day, "days")
                    .format("YYYY-MM-DD")
                : null;

              updatedEmbryo[innerIndex]["date_of_freezing"] = date;
            }
          }
        }

        // Check D3 Count for Blastocyst (Stage of Development)
        const date1 = moment(values?.day_0_date, "YYYY-MM-DD");
        const convertDate = convertToCommonDateFormat(item.date_of_freezing);
        const date2 = convertDate ? moment(convertDate, "YYYY-MM-DD") : null;

        if (item?.date_of_freezing && date2) {
          const diffInDays = date2?.diff(date1, "days");
          if (3 === diffInDays) countD3++;
        }
      });

      if (
        key === "fert_check" &&
        ["Degenerated", "Lysed", "Unfert"].includes(value?.value)
      ) {
        assignEDSTableEmptyValueFields.forEach((field) => {
          updatedEmbryo[innerIndex][field] = null;
        });
      }

      // Compute kept_for_blastocyst
      const keptForBlast = parseInt(cleaved || 0) - countD3;

      // Update counters
      updatedRow.embryo = updatedEmbryo;
      updatedRow.fert = fert;
      updatedRow.unfert = unfert;
      updatedRow.degenerated = degenerated;
      updatedRow.total_blastocyst = total_blastocyst;
      updatedRow.cleaved = cleaved;
      updatedRow.kept_for_blastocyst = keptForBlast;

      // Calculate and update kept for blastocyst
      // const keptForBlast = parseInt(updatedRow["cleaved"] || 0) - countD3;
      // updatedRow.kept_for_blastocyst = keptForBlast;

      // if (
      //   key === "fert_check" &&
      //   ["Degenerated", "Lysed", "Unfert"].includes(value?.value)
      // ) {
      //   assignEDSTableEmptyValueFields.forEach((field) => {
      //     //   obj[`${field}${mainIndex}${innerIndex}`] = null;
      //     updatedEmbryo[innerIndex][field] = null;
      //   });
      // }

      //   setEmbryology_count(updatedEmbryoCounter);

      const updatedData = [...tableData];
      updatedData[mainIndex] = updatedRow;

      // Efficient unique vitrification_id count for Total-Straw
      const countOfUniqueIds =
        new Set(
          updatedData.flatMap((row) =>
            row.embryo?.map((e) => e?.vitrification_id).filter(Boolean)
          )
        ).size || 0;

      setFieldValue("total_straw", countOfUniqueIds);
      setFieldValue("oocytes", updatedData);
    },
    [setFieldValue, tableData, values?.day_0_date]
  );

  // const handleOccyteTableChange = useCallback(
  //   (innerIndex, mainIndex, value, key) => {
  //     let updatedEmbryoCounter = JSON.parse(JSON.stringify([...tableData]));
  //     let obj = {};
  //     let fert = 0;
  //     let cleaved = 0;
  //     let unfert = 0;
  //     let degenerated = 0;
  //     let total_blastocyst = 0;
  //     let countD3 = 0;
  //     let grade = "";
  //     let uniqueVitrificationIds = new Set();
  //     // obj[`${key}${mainIndex}${innerIndex}`] = value;
  //     updatedEmbryoCounter[mainIndex].embryo[innerIndex][key] = value;

  //     if (key === "goblet_color" && innerIndex === 0) {
  //       const firstRowColor = value;

  //       updatedEmbryoCounter[mainIndex].embryo.forEach((item, forEachIndex) => {
  //         if (item["date_of_freezing"] && item["vitrification_id"]) {
  //           item["goblet_color"] = firstRowColor;
  //           obj[`goblet_color${mainIndex}${forEachIndex}`] = firstRowColor;
  //         }
  //       });
  //     }

  //     updatedEmbryoCounter[mainIndex].embryo.forEach((item) => {
  //       // General handling for the value update
  //       item[key] = item[key] === undefined ? value : item[key];

  //       // Fertility Check Logic
  //       switch (item?.fert_check) {
  //         case "1PN":
  //         case "2PN":
  //         case "3PN":
  //         case "2 Cell":
  //           fert++;
  //           break;
  //         case "Unfert":
  //           unfert++;
  //           break;
  //         case "Degenerated":
  //           degenerated++;
  //           break;
  //         default:
  //           break;
  //       }

  //       // Cleaved Logic (Embryo Grade)
  //       switch (item?.embryo_grade) {
  //         case "Grade-I":
  //         case "Grade-II":
  //         case "Grade-III":
  //           cleaved++;
  //           break;
  //         case "D3 Arrested":
  //           obj[`date_of_freezing${mainIndex}${innerIndex}`] = null;
  //           updatedEmbryoCounter[mainIndex].embryo[innerIndex][
  //             "date_of_freezing"
  //           ] = null;
  //           cleaved++;
  //           break;
  //         case "Lysed":
  //           obj[`date_of_freezing${mainIndex}${innerIndex}`] = null;
  //           updatedEmbryoCounter[mainIndex].embryo[innerIndex][
  //             "date_of_freezing"
  //           ] = null;
  //           break;
  //         default:
  //           break;
  //       }
  //       updatedEmbryoCounter[mainIndex].cleaved = cleaved;
  //       obj[`cleaved${mainIndex}`] = cleaved;

  //       // Vitrification ID and Freezing Date Logic
  //       if (item?.vitrification_id) {
  //         uniqueVitrificationIds.add(item?.vitrification_id);
  //       }
  //       if (key === "date_of_freezing") {
  //         obj[`date_of_freezing${mainIndex}${innerIndex}`] = value
  //           ? dayjs(moment(value).format("DD/MM/YYYY"), "DD/MM/YYYY")
  //           : null;
  //       }

  //       // Stage of Development Logic (Freezing Date & Rating)
  //       if (key === "stage_of_development") {
  //         obj[`date_of_freezing${mainIndex}${innerIndex}`] = null;

  //         obj[`rating${mainIndex}${innerIndex}`] = null;
  //         obj[`blasto_score${mainIndex}${innerIndex}`] = null;

  //         let day = days[value];
  //         if (
  //           ["D3 Arrested", "Lysed"].includes(
  //             updatedEmbryoCounter[mainIndex].embryo[innerIndex]["embryo_grade"]
  //           )
  //         ) {
  //           obj[`date_of_freezing${mainIndex}${innerIndex}`] = null;
  //         } else {
  //           if (day) {
  //             obj[`date_of_freezing${mainIndex}${innerIndex}`] =
  //               embryologyDetails?.day_0_date
  //                 ? dayjs(
  //                     moment(embryologyDetails?.day_0_date)
  //                       .add(day, "days")
  //                       .format("DD/MM/YYYY"),
  //                     "DD/MM/YYYY"
  //                   )
  //                 : null;
  //             updatedEmbryoCounter[mainIndex].embryo[innerIndex][
  //               "date_of_freezing"
  //             ] = moment(embryologyDetails?.day_0_date)
  //               .add(day, "days")
  //               .format("DD/MM/YYYY");
  //           }
  //         }
  //       }

  //       // Blastocyst Score Logic
  //       if (item?.blasto_score) {
  //         total_blastocyst++;
  //       }
  //       if (key === "blasto_score" && value) {
  //         //   const formValues = form.getFieldsValue();
  //         const formValues = {};
  //         const stage =
  //           formValues[`stage_of_development${mainIndex}${innerIndex}`];
  //         if (stage) {
  //           const handleScore = {
  //             D5: handleBlastoScore(
  //               value,
  //               checkD5GoodValues,
  //               checkD5FairValues,
  //               checkD5PoorValues
  //             ),
  //             D6: handleBlastoScore(
  //               value,
  //               checkD6GoodValues,
  //               checkD6FairValues,
  //               checkD6PoorValues
  //             ),
  //             D7: handleBlastoScore(
  //               value,
  //               checkD7GoodValues,
  //               checkD7FairValues,
  //               checkD7PoorValues
  //             )
  //           };
  //           grade = handleScore[stage] || "";
  //         }

  //         obj[`rating${mainIndex}${innerIndex}`] = grade;
  //         updatedEmbryoCounter[mainIndex].embryo[innerIndex]["rating"] = grade;
  //       }
  //       // Check D3 Count for Blastocyst (Stage of Development)

  //       const date1 = moment(embryologyDetails?.day_0_date, "YYYY-MM-DD");
  //       const convertDate = convertToCommonDateFormat(item.date_of_freezing);
  //       const date2 = convertDate ? moment(convertDate, "YYYY-MM-DD") : null;
  //       if (item?.date_of_freezing && date2) {
  //         const diffInDays = date2?.diff(date1, "days");
  //         if (3 === diffInDays) countD3++;
  //       }
  //     });

  //     // Update counters
  //     updatedEmbryoCounter[mainIndex].fert = fert;
  //     updatedEmbryoCounter[mainIndex].unfert = unfert;
  //     updatedEmbryoCounter[mainIndex].degenerated = degenerated;
  //     updatedEmbryoCounter[mainIndex].total_blastocyst = total_blastocyst;

  //     const countOfUniqueIds = uniqueVitrificationIds.size;
  //     dispatch(
  //       setEmbryologyDetails({
  //         ...embryologyDetails,
  //         total_straw: countOfUniqueIds || 0
  //       })
  //     );

  //     // Calculate and update kept for blastocyst
  //     const keptForBlast =
  //       parseInt(updatedEmbryoCounter[mainIndex]["cleaved"] || 0) - countD3;
  //     updatedEmbryoCounter[mainIndex].kept_for_blastocyst = keptForBlast;
  //     if (
  //       key === "fert_check" &&
  //       ["Degenerated", "Lysed", "Unfert"].includes(value)
  //     ) {
  //       assignEDSTableEmptyValueFields.forEach((field) => {
  //         obj[`${field}${mainIndex}${innerIndex}`] = null;
  //       });
  //     }
  //     obj[`kept_for_blastocyst${mainIndex}`] = keptForBlast;
  //     obj[`total_straw`] = countOfUniqueIds || 0;
  //     obj[`fert${mainIndex}`] = fert;
  //     obj[`unfert${mainIndex}`] = unfert;
  //     obj[`degenerated${mainIndex}`] = degenerated;
  //     obj[`total_blastocyst${mainIndex}`] = total_blastocyst;

  //     // Set the form and state with the updated data
  //     //   form.setFieldsValue({
  //     //     ...obj
  //     //   });

  //     setEmbryology_count(updatedEmbryoCounter);
  //   },
  //   [embryologyDetails]
  // );

  const handleCountOnRemoval = useCallback(
    (tableData, updatedEmbryo, mainIndex) => {
      const tableRow = tableData[mainIndex];
      // const embryoCounter = row;

      let fert = 0;
      let unfert = 0;
      let countD3 = 0;
      let cleaved = 0;
      let degenerated = 0;
      let totalBlastocyst = 0;

      const uniqueVitrificationIds = new Set();
      const day0Date = moment(values?.day_0_date, "YYYY-MM-DD");

      // Update embryo list
      tableRow.embryo = updatedEmbryo;

      // Collect vitrification IDs
      for (const { embryo } of tableData) {
        for (const item of embryo || []) {
          const vitrId = item?.vitrification_id;
          if (vitrId) uniqueVitrificationIds.add(vitrId);
        }
      }

      // Group by maturation_stage
      const maturationGroup = Object.groupBy(
        updatedEmbryo,
        (e) => e?.maturation_stage || ""
      );

      for (const row of updatedEmbryo) {
        if (["1PN", "2PN", "3PN", "2 Cell"].includes(row?.fert_check?.value)) {
          fert++;
        }
        if (row?.fert_check?.value === "Unfert") unfert++;
        if (row?.fert_check?.value === "Degenerated") degenerated++;

        if (
          ["Grade-I", "Grade-II", "Grade-III", "D3 Arrested"].includes(
            row?.embryo_grade?.value
          )
        ) {
          cleaved++;
        }

        if (row?.blasto_score) {
          totalBlastocyst++;
        }

        const freezeDate = convertToCommonDateFormat(row.date_of_freezing);

        if (freezeDate) {
          const freezeMoment = moment(freezeDate, "YYYY-MM-DD");
          if (freezeMoment.diff(day0Date, "days") === 3) countD3++;
        }
      }

      tableRow.total_m2 = maturationGroup["M2"]?.length || 0;
      tableRow.total_m1 = maturationGroup["M1"]?.length || 0;
      tableRow.unfert = unfert;
      tableRow.fert = fert;
      tableRow.degenerated = degenerated;
      tableRow.cleaved = cleaved;
      tableRow.kept_for_blastocyst = cleaved - countD3;
      tableRow.total_blastocyst = totalBlastocyst;

      // Optional: update straw count if needed
      setFieldValue("total_straw", uniqueVitrificationIds.size || 0);

      // dispatch(
      //   setEmbryologyDetails({
      //     ...embryologyDetails,
      //     total_straw: uniqueVitrificationIds.size || 0
      //   })
      // );
    },
    [dispatch, setFieldValue]
  );

  // const handleCountOnRemoval = useCallback(
  //   (
  //     vitrificationEmbryoData,
  //     updatedPackData,
  //     // obj1,
  //     updatedEmbryoCounter,
  //     index
  //   ) => {
  //     let fert = 0;
  //     let cleaved = 0;
  //     let unfert = 0;
  //     let degenerated = 0;
  //     let total_blastocyst = 0;
  //     let countD3 = 0;

  //     const uniqueVitrificationIds = new Set();

  //     vitrificationEmbryoData[index].embryo = updatedPackData;
  //     vitrificationEmbryoData?.forEach((record) => {
  //       record?.embryo?.forEach((embryo) => {
  //         if (
  //           embryo?.vitrification_id !== null &&
  //           embryo?.vitrification_id !== ""
  //         ) {
  //           uniqueVitrificationIds?.add(embryo?.vitrification_id);
  //         }
  //       });
  //     });

  //     const embryoGroups = Object.groupBy(
  //       updatedEmbryoCounter[index]["embryo"],
  //       ({ maturation_stage }) => maturation_stage
  //     );

  //     // const countOfUniqueIds = uniqueVitrificationIds?.size;
  //     // dispatch(
  //     //   setEmbryologyDetails({
  //     //     ...embryologyDetails,
  //     //     total_straw: countOfUniqueIds || 0
  //     //   })
  //     // );
  //     //   form.setFieldsValue({
  //     //     total_straw: countOfUniqueIds || 0
  //     //   });

  //     updatedPackData?.forEach((row) => {
  //       switch (row?.fert_check?.value) {
  //         case "1PN":
  //           fert++;
  //           break;
  //         case "2PN":
  //           fert++;
  //           break;
  //         case "3PN":
  //           fert++;
  //           break;
  //         case "2 Cell":
  //           fert++;
  //           break;
  //         // case "Abnormal PN":
  //         //   fert++;
  //         //   break;
  //         case "Unfert":
  //           unfert++;
  //           break;
  //         case "Degenerated":
  //           degenerated++;
  //           break;
  //         default:
  //           break;
  //       }

  //       switch (row?.embryo_grade?.value) {
  //         case "Grade-I":
  //           cleaved++;
  //           break;
  //         case "Grade-II":
  //           cleaved++;
  //           break;
  //         case "Grade-III":
  //           cleaved++;
  //           break;
  //         case "D3 Arrested":
  //           cleaved++;
  //           break;
  //         default:
  //           break;
  //       }

  //       const date1 = moment(embryologyDetails?.day_0_date, "YYYY-MM-DD");
  //       const convertDate = convertToCommonDateFormat(row.date_of_freezing);
  //       const date2 = convertDate ? moment(convertDate, "YYYY-MM-DD") : null;
  //       if (row?.date_of_freezing && date2) {
  //         const diffInDays = date2?.diff(date1, "days");
  //         if (3 === diffInDays) countD3++;
  //       }

  //       if (row?.blasto_score) {
  //         total_blastocyst++;
  //       }
  //     });

  //     updatedEmbryoCounter[index]["total_m2"] = embryoGroups["M2"]?.length || 0;
  //     updatedEmbryoCounter[index]["total_m1"] = embryoGroups["M1"]?.length || 0;

  //     updatedEmbryoCounter[index]["unfert"] = unfert || 0;
  //     // obj1[`unfert${index}`] = unfert || 0;

  //     updatedEmbryoCounter[index]["fert"] = fert || 0;
  //     // obj1[`fert${index}`] = fert || 0;

  //     updatedEmbryoCounter[index]["degenerated"] = degenerated || 0;
  //     // obj1[`degenerated${index}`] = degenerated || 0;

  //     updatedEmbryoCounter[index].cleaved = cleaved || 0;
  //     // obj1[`cleaved${index}`] = cleaved || 0;

  //     const keptForBlast =
  //       parseInt(updatedEmbryoCounter[index]["cleaved"] || 0) - countD3;
  //     updatedEmbryoCounter[index]["kept_for_blastocyst"] = keptForBlast;

  //     // obj1[`kept_for_blastocyst${index}`] = keptForBlast;

  //     updatedEmbryoCounter[index].total_blastocyst = total_blastocyst;
  //     // obj1[`total_blastocyst${index}`] = total_blastocyst;
  //   },
  //   [dispatch, embryologyDetails]
  // );

  // const onDeleteEmbryoData = useCallback(
  //   (mainIndex, subIndex, maturation) => {

  //     // const updatedTableData = [...tableData];
  //     // const updatedRow = { ...updatedTableData[mainIndex] };
  //     // const updatedEmbryo = [...updatedRow.embryo];

  //     // updatedEmbryo.splice(subIndex, 1);

  //     // const vitrificationEmbryoData = updatedEmbryo;

  //     // const copyList1 = updatedEmbryo;

  //     // const updatedPackData = [...copyList1];
  //     // const obj1 = {};

  //     const updatedTableData = [...tableData];
  //     const updatedRow = { ...updatedTableData[mainIndex] };
  //     const updatedEmbryo = [...updatedRow.embryo];
  //     updatedEmbryo.splice(subIndex, 1);

  //     // updatedRow.embryo = updatedEmbryo;
  //     // updatedTableData[mainIndex] = updatedRow;

  //     // let updatedEmbryoCounter = JSON.parse(JSON.stringify(tableData));
  //     // updatedEmbryoCounter[mainIndex].embryo.splice(subIndex, 1);
  //     // let vitrificationEmbryoData = updatedEmbryoCounter;
  //     // let copyList = updatedEmbryoCounter[mainIndex].embryo;
  //     // let updatedPackData = JSON.parse(JSON.stringify([...copyList])); // Copy existing data
  //     // let obj1 = {};

  //     updatedEmbryo.splice(subIndex, 1);

  //     const reIndexedEmbryo = updatedEmbryo.map((item, index) => ({
  //       ...item,
  //       oocytes: index + 1
  //     }));

  //     updatedRow.embryo = reIndexedEmbryo;
  //     updatedTableData[mainIndex] = updatedRow;

  //     handleCountOnRemoval(
  //       updatedTableData,
  //       updatedEmbryo,
  //       updatedTableData,
  //       mainIndex
  //     );

  //     setFieldValue("oocytes", updatedTableData);

  //     // dispatch(setEmbryology_count(updatedEmbryoCounter));

  //     // obj1[`total_m1${subIndex}`] = updatedTableData[mainIndex].embryo.filter(
  //     //   (emb) => emb.maturation_stage === "M1"
  //     // ).length;
  //     // obj1[`total_m2${subIndex}`] = updatedTableData[mainIndex].embryo.filter(
  //     //   (emb) => emb.maturation_stage === "M2"
  //     // ).length;

  //     // updatedTableData[mainIndex]?.embryo?.length &&
  //     //   updatedTableData[mainIndex].embryo.reduce((obj, item, i) => {
  //     //     obj1[`maturation_stage${mainIndex}${i}`] = item.maturation_stage;
  //     //     obj1[`oocytes${mainIndex}${i}`] = i + 1;
  //     //     obj1[`oocytes_quality${mainIndex}${i}`] = item.oocytes_quality;
  //     //     obj1[`fert_check${mainIndex}${i}`] = item.fert_check;
  //     //     obj1[`stage_of_development${mainIndex}${i}`] =
  //     //       item.stage_of_development;
  //     //     obj1[`embryo_grade${mainIndex}${i}`] = item.embryo_grade;
  //     //     obj1[`blasto_score${mainIndex}${i}`] = item.blasto_score;
  //     //     obj1[`rating${mainIndex}${i}`] = item.rating;
  //     //     obj1[`et_status${mainIndex}${i}`] = item?.et_status || null;
  //     //     obj1[`provider${mainIndex}${i}`] = item?.provider || null;
  //     //     obj1[`provider_other${mainIndex}${i}`] = item?.provider_other || null;
  //     //     obj1[`introducer${mainIndex}${i}`] = item?.introducer || null;
  //     //     obj1[`introducer_other${mainIndex}${i}`] =
  //     //       item?.introducer_other || null;
  //     //     obj1[`complication${mainIndex}${i}`] = item?.complication || null;
  //     //     obj1[`date_of_freezing${mainIndex}${i}`] = item?.date_of_freezing
  //     //       ? dayjs(
  //     //           moment(item?.date_of_freezing).format("DD/MM/YYYY"),
  //     //           "DD/MM/YYYY"
  //     //         )
  //     //       : null;
  //     //     obj1[`vitrification_id${mainIndex}${i}`] =
  //     //       item?.vitrification_id || null;
  //     //     obj1[`straw_color${mainIndex}${i}`] = item?.straw_color || null;
  //     //     obj1[`straw_color_other${mainIndex}${i}`] =
  //     //       item?.straw_color_other || null;
  //     //     obj1[`goblet_color${mainIndex}${i}`] = item?.goblet_color || null;
  //     //     obj1[`goblet_color_other${mainIndex}${i}`] =
  //     //       item?.goblet_color_other || null;
  //     //     obj1[`vitrified_by${mainIndex}${i}`] = item?.vitrified_by || null;
  //     //     obj1[`status${mainIndex}${i}`] = item?.status || null;
  //     //     obj1[`well_no${mainIndex}${i}`] = item?.well_no || null;
  //     //   });

  //     //   form.setFieldsValue(obj1);
  //   },
  //   [dispatch, handleCountOnRemoval, tableData]
  // );

  // const handleOptionChange = useCallback(
  //   (fieldName, newValue) => {
  //     handleEmbryoChange(i, index, fieldName, newValue);
  //   },
  //   [handleEmbryoChange, i, index]
  // );

  const onDeleteEmbryoData = useCallback(
    (mainIndex, subIndex) => {
      const updatedTableData = [...tableData];
      const updatedRow = { ...updatedTableData[mainIndex] };

      // Remove embryo at subIndex
      const updatedEmbryo = updatedRow.embryo.filter((_, i) => i !== subIndex);

      // Re-index oocytes
      const reIndexedEmbryo = updatedEmbryo.map((item, idx) => ({
        ...item,
        oocytes: idx + 1,
      }));

      // Update the row
      updatedRow.embryo = reIndexedEmbryo;
      updatedTableData[mainIndex] = updatedRow;

      // Call the count updater
      // handleCountOnRemoval(
      //   updatedTableData,
      //   reIndexedEmbryo,
      //   updatedTableData,
      //   mainIndex
      // );

      handleCountOnRemoval(updatedTableData, reIndexedEmbryo, mainIndex);

      setFieldValue("oocytes", updatedTableData);
    },
    [tableData, setFieldValue, handleCountOnRemoval]
  );

  const handleFertCheckCondition = useMemo(() => {
    if (item?.fert_check?.value) {
      return ["Degenerated", "Unfert", "Lysed"].includes(
        item?.fert_check?.value
      );
    }
    return false;
  }, [item?.fert_check]);

  const handleBlastoScoreCondition = useMemo(() => {
    if (item?.blasto_score) {
      return item?.blasto_score?.toLowerCase()?.trim() === "arrested";
    }
    return false;
  }, [item?.blasto_score]);

  const handleVitrificationIdCondition = useMemo(() => {
    // if (item?.vitrification_id) {
    return !item?.vitrification_id?.trim();
    // }
    // return false;
  }, [item?.vitrification_id]);

  //  const disableEmbryoGrade = useCallback((grade) => {
  //   const specialGrades = ["D3 Arrested", "Lysed", "NA"];
  //   return specialGrades.includes(grade);
  // }, []);

  const checkEmbryoGradeValidation = useMemo(() => {
    const specialGrades = ["D3 Arrested", "Lysed", "NA"];
    return specialGrades.includes(item?.embryo_grade?.value);
  }, [item?.embryo_grade]);

  const OocytesFieldTd = useMemo(() => {
    return (
      <td className="custom_normal_input">
        {/* <div className="w_150">
          <Form.Item name={`oocytes${i}${index}`} className="mb-1">
            <Input placeholder="Oocytes" value={item.oocytes} disabled />
          </Form.Item>
        </div> */}
        <input
          type="number"
          //   name={`oocytes.[${i}].embryo[${index}].oocytes`}
          value={item?.oocytes}
          //   onChange={(e) =>
          //     setFieldValue(`embryos[${index}].oocytes`, e.target.value)
          //   }
          onChange={(e) =>
            handleEmbryoChange(i, index, "oocytes", e.target.value)
          }
          placeholder="Oocytes"
          disabled
        />
      </td>
    );
  }, [item.oocytes]);

  const MaturationStageFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_200 custom_normal_input">
          {/* <Form.Item
            // name={`maturation_stage${i}${index}`}
            // name={`oocytes[${i}].embryo[${index}].maturation_stage`}
            name={`embryo[${index}].maturation_stage`}
            className="custom_select mb-1"
          >
            <Input
              placeholder="Maturation Stage"
              value={item?.maturation_stage}
              disabled
            />
          </Form.Item> */}
          <input
            // name={`embryo[${index}].maturation_stage`}
            value={item?.maturation_stage}
            // onChange={(e) =>
            //   setFieldValue(`embryo[${index}].maturation_stage`, e.target.value)
            // }
            onChange={(e) =>
              handleEmbryoChange(i, index, "maturation_stage", e.target.value)
            }
            // onChange={handleChange}
            placeholder="Maturation Stage"
            disabled
          />
        </div>
      </td>
    );
  }, [handleEmbryoChange, item?.maturation_stage]);

  const OocytesQualityFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_200 custom-normal-select">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "oocytes_quality", e.target.value)
            }
          >
            {oocytesQualityOptions?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <CustomCreatableSelect
            isMulti
            name="oocytes_quality"
            options={oocytesQualityOptions}
            value={item?.oocytes_quality}
            onChange={(value) => {
              handleEmbryoChange(i, index, "oocytes_quality", value);
            }}
          />

          {/* <Form.Item
            name={`oocytes_quality${i}${index}`}
            className="custom_select mb-1"
          >
            <Select
              placeholder="Select"
              value={item?.oocytes_quality}
              mode="multiple"
              maxTagCount="responsive"
              maxTagPlaceholder={(QualityofEgg) => (
                <Tooltip
                  title={QualityofEgg.map(({ label }) => label).join(", ")}
                >
                  <span>Hover Me</span>
                </Tooltip>
              )}
              onChange={(value) => {
                handleOccyteTableChange(
                  index,
                  i,
                  value || null,
                  "oocytes_quality"
                );
              }}
              options={oocytesQualityOptions}
            />
          </Form.Item> */}
        </div>
      </td>
    );
  }, [item?.oocytes_quality, handleEmbryoChange]);

  const FertCheckFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_200 custom-normal-select">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "fert_check", e.target.value)
            }
          >
            {fertCheckOptions?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <CustomCreatableSelect
            name="fert_check"
            value={item?.fert_check}
            options={fertCheckOptions}
            onChange={(value) => {
              handleEmbryoChange(i, index, "fert_check", value);
            }}
            // disabled={disabledField("fert_check", item)}
          />

          {/* <Form.Item
            name={`fert_check${i}${index}`}
            className="custom_select mb-1"
          >
            <Select
              showSearch
              disabled={disabledField("fert_check")}
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select"
              value={item?.fert_check}
              onChange={(value) => {
                handleOccyteTableChange(index, i, value || null, "fert_check");
              }}
              options={fertCheckOptions}
            />
          </Form.Item> */}
        </div>
      </td>
    );
  }, [item?.fert_check, handleEmbryoChange]);

  const StageOfDevelopmentFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_220 custom-normal-select">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(
                i,
                index,
                "stage_of_development",
                e.target.value
              )
            }
          >
            {stageOfDevOptions?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <CustomCreatableSelect
            name="stage_of_development"
            value={item?.stage_of_development}
            options={stageOfDevOptions}
            onChange={(value) => {
              handleEmbryoChange(i, index, "stage_of_development", value);
            }}
            disabled={
              // disabledField("stage_of_development", item) ||
              handleFertCheckCondition
            }
          />

          {/* <Form.Item
            name={`stage_of_development${i}${index}`}
            className="custom_select mb-1"
          >
            <Select
              showSearch
              disabled={
                disabledField("stage_of_development") ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check)
              }
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select"
              value={item?.stage_of_development}
              onChange={(value) => {
                handleOccyteTableChange(
                  index,
                  i,
                  value || null,
                  "stage_of_development"
                );
              }}
              options={stageOfDevOptions}
            />
          </Form.Item> */}
        </div>
      </td>
    );
  }, [
    item?.stage_of_development,
    handleEmbryoChange,
    handleFertCheckCondition,
  ]);

  const EmbryoGradeFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_200">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "embryo_grade", e.target.value)
            }
            disabled={
                disabledField("embryo_grade") ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check)
              }
          >
            {embryoGradeOptions?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <div
            className={`${
              item?.embryo_history?.length ? "w_custom" : "w-full"
            } custom-normal-select`}
          >
            <Stack
              direction="horizontal"
              alignItems="center"
              display="flex"
              gap={2}
            >
              <CustomCreatableSelect
                name="embryo_grade"
                value={item?.embryo_grade}
                options={embryoGradeOptions}
                onChange={(value) => {
                  handleEmbryoChange(i, index, "embryo_grade", value);
                }}
                disabled={
                  // disabledField("embryo_grade", item) ||
                  handleFertCheckCondition
                }
              />

              {item?.embryo_history?.length ? (
                <Tooltip
                  title={formattedTooltipOutput(item?.embryo_history)}
                  placement="bottom"
                >
                  <InfoCircleOutlined
                    className="grade_icon"
                    style={{ cursor: "help" }}
                  />
                </Tooltip>
              ) : (
                ""
              )}
            </Stack>
          </div>

          {/* <Form.Item
            name={`embryo_grade${i}${index}`}
            className="custom_select mb-1"
          > */}
          {/* <Stack
            direction="horizontal"
            alignItems="center"
            display="flex"
            gap={2}
          >
            <Select
              showSearch
              disabled={
                disabledField("embryo_grade") ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check)
              }
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select"
              value={item?.embryo_grade}
              onChange={(value) => {
                //   handleOccyteTableChange(
                //     index,
                //     i,
                //     value || null,
                //     "embryo_grade"
                //   );
                handleEmbryoChange(i, index, "embryo_grade", value || null);
              }}
              options={embryoGradeOptions}
            />
            {!!item?.embryo_history?.length && (
              <Tooltip
                title={formattedTooltipOutput(item?.embryo_history)}
                placement="bottom"
              >
                <InfoCircleOutlined
                  className="grade_icon"
                  style={{ cursor: "help" }}
                />
              </Tooltip>
            )}
          </Stack> */}
          {/* </Form.Item>  */}
        </div>
      </td>
    );
  }, [item?.embryo_grade, handleEmbryoChange, handleFertCheckCondition]);

  const BlastoScoreFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_150 custom_normal_input">
          <input
            onChange={(e) =>
              handleEmbryoChange(i, index, "blasto_score", e.target.value)
            }
            disabled={
              disabledField("blasto_score", item, i, index) ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
            value={item.blasto_score || ""}
            placeholder="Blasto Score"
          />

          {/* <Form.Item name={`blasto_score${i}${index}`} className="mb-1">
            <Input
              placeholder="Blasto Score"
              disabled={
                // disabledField("embryo_grade") ||
                disabledField("blasto_score", i, index) ||
                // ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                // item?.stage_of_development === 'D3' ||
                disableEmbryoGrade(item?.embryo_grade)
              }
              value={item?.blasto_score}
              onChange={(e) => {
                handleOccyteTableChange(
                  index,
                  i,
                  e.target.value || "",
                  "blasto_score"
                );
              }}
            />
          </Form.Item> */}
        </div>
      </td>
    );
  }, [
    item?.embryo_grade,
    item.blasto_score,
    handleEmbryoChange,
    disabledField,
    checkEmbryoGradeValidation,
  ]);

  const RatingFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_90 custom_normal_input">
          <input
            // type="number"
            onChange={(e) =>
              handleEmbryoChange(i, index, "rating", e.target.value)
            }
            value={item.rating || ""}
            placeholder="rating"
            disabled
          />

          {/* <Form.Item name={`rating${i}${index}`} className="mb-1">
            <Input placeholder="Rating" value={item?.rating} disabled />
          </Form.Item> */}
        </div>
      </td>
    );
  }, [item.rating, handleEmbryoChange]);

  const ETStatusFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_170 custom-normal-select">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "et_status", e.target.value)
            }
            disabled={
              disabledField("et_status") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              disableEmbryoGrade(item?.embryo_grade)
            }
          >
            {etStatusOptions?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <CustomCreatableSelect
            name="et_status"
            value={item?.et_status}
            options={etStatusOptions}
            onChange={(value) => {
              handleEmbryoChange(i, index, "et_status", value);
            }}
            disabled={
              disabledField("et_status", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item
            name={`et_status${i}${index}`}
            className="custom_select mb-1"
          > */}
          {/* <Select
            disabled={
              disabledField("et_status") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              disableEmbryoGrade(item?.embryo_grade)
            }
            showSearch
            allowClear={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder="Select"
            value={item?.et_status}
            onChange={(value) => {
              //   handleOccyteTableChange(index, i, value || null, "et_status");
              handleEmbryoChange(i, index, "et_status", value || null);
            }}
            options={etStatusOptions}
          /> */}
          {/* </Form.Item>  */}
        </div>
      </td>
    );
  }, [
    item?.et_status,
    handleEmbryoChange,
    disabledField,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
  ]);

  const ProviderFieldTd = useMemo(() => {
    return item?.et_status?.value === "Fresh ET" ? (
      <td>
        <div className="w_170 custom-normal-select">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "provider", e.target.value)
            }
            disabled={
              disabledField("provider") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              disableEmbryoGrade(item?.embryo_grade)
            }
          >
            {etProvider?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <CustomCreatableSelect
            name="provider"
            value={item?.provider}
            options={etProvider}
            onChange={(value) => {
              handleEmbryoChange(i, index, "provider", value);
            }}
            onCreate={(value) => {
              handleEmbryoChange(i, index, "provider", value);
            }}
            disabled={
              // disabledField("provider", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item
            name={`provider${i}${index}`}
            className="custom_select mb-1"
          > */}
          {/* <Select
            disabled={
              disabledField("provider") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              disableEmbryoGrade(item?.embryo_grade)
            }
            showSearch
            allowClear={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder="Select"
            value={item?.provider}
            onChange={(value) => {
              handleOccyteTableChange(index, i, value || null, "provider");
            }}
            options={etProvider}
          /> */}
          {/* </Form.Item>  */}
        </div>
      </td>
    ) : (
      <td>
        <div className="w_170"></div>
      </td>
    );
  }, [
    item?.et_status,
    handleEmbryoChange,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
  ]);

  const ProviderOtherFieldTd = useMemo(() => {
    return item.provider?.value === "OTHER" ? (
      <td>
        <div className="w_170 custom_normal_input">
          <input
            onChange={(e) =>
              handleEmbryoChange(i, index, "provider_other", e.target.value)
            }
            disabled={
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
            value={item.provider_other || ""}
            placeholder="Provider Other"
          />

          {/* <Form.Item name={`provider_other${i}${index}`} className="mb-1">
            <Input
              disabled={
                item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                disableEmbryoGrade(item?.embryo_grade)
              }
              placeholder="Provider Other"
              value={item?.provider_other}
              onChange={(e) => {
                handleOccyteTableChange(
                  index,
                  i,
                  e.target.value || "",
                  "provider_other"
                );
              }}
            />
          </Form.Item> */}
        </div>
      </td>
    ) : (
      <td>
        <div className="w_120"></div>
      </td>
    );
  }, [
    item.provider,
    item.provider_other,
    handleEmbryoChange,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
  ]);

  const IntroducerFieldTd = useMemo(() => {
    return item?.et_status?.value === "Fresh ET" ? (
      <td>
        <div className="w_170 custom-normal-select">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "introducer", e.target.value)
            }
            disabled={
                disabledField("introducer") ||
                item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                disableEmbryoGrade(item?.embryo_grade)
              }
          >
            {etProvider?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <CustomCreatableSelect
            name="introducer"
            value={item?.introducer}
            options={etProvider}
            onChange={(value) => {
              handleEmbryoChange(i, index, "introducer", value);
            }}
            onCreate={(value) => {
              handleEmbryoChange(i, index, "introducer", value);
            }}
            disabled={
              // disabledField("introducer", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item
            name={`introducer${i}${index}`}
            className="custom_select mb-1"
          > */}
          {/* <Select
            disabled={
              disabledField("introducer") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              disableEmbryoGrade(item?.embryo_grade)
            }
            showSearch
            allowClear={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder="Select"
            value={item?.introducer}
            onChange={(value) => {
              //   handleOccyteTableChange(index, i, value || null, "introducer");
              handleEmbryoChange(i, index, "introducer", value || null);
            }}
            options={etProvider}
          /> */}
          {/* </Form.Item>  */}
        </div>
      </td>
    ) : (
      <td>
        <div className="w_170"></div>
      </td>
    );
  }, [
    item?.et_status,
    item?.introducer,
    handleEmbryoChange,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
  ]);

  const IntroducerOtherFieldTd = useMemo(() => {
    return item.introducer?.value === "OTHER" ? (
      <td>
        <div className="w_170 custom_normal_input">
          <input
            onChange={(e) =>
              handleEmbryoChange(i, index, "introducer_other", e.target.value)
            }
            disabled={
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
            value={item.introducer_other || ""}
            placeholder="Introducer Other"
          />

          {/* <Form.Item name={`introducer_other${i}${index}`} className="mb-1">
            <Input
              disabled={
                item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                disableEmbryoGrade(item?.embryo_grade)
              }
              placeholder="Introducer Other"
              value={item?.introducer_other}
              onChange={(e) => {
                handleOccyteTableChange(
                  index,
                  i,
                  e.target.value || "",
                  "introducer_other"
                );
              }}
            />
          </Form.Item> */}
        </div>
      </td>
    ) : (
      <td>
        <div className="w_120"></div>
      </td>
    );
  }, [
    item.introducer,
    item.introducer_other,
    handleEmbryoChange,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
  ]);

  const ComplicationFieldTd = useMemo(() => {
    return item?.et_status?.value === "Fresh ET" ? (
      <td>
        <div className="w_170 custom-normal-select">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "complication", e.target.value)
            }
              disabled={
              disabledField("complication") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              disableEmbryoGrade(item?.embryo_grade)
            }
          >
            {complicationOptions?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <CustomCreatableSelect
            name="complication"
            value={item?.complication}
            options={complicationOptions}
            onChange={(value) => {
              handleEmbryoChange(i, index, "complication", value);
            }}
            onCreate={(value) => {
              handleEmbryoChange(i, index, "complication", value);
            }}
            disabled={
              // disabledField("complication", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item
            name={`complication${i}${index}`}
            className="custom_select mb-1"
          > */}
          {/* <Select
            disabled={
              disabledField("complication") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              disableEmbryoGrade(item?.embryo_grade)
            }
            showSearch
            allowClear={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder="Select"
            value={item?.complication}
            onChange={(value) => {
              handleOccyteTableChange(index, i, value || null, "complication");
            }}
            options={complicationOptions}
          /> */}
          {/* </Form.Item>  */}
        </div>
      </td>
    ) : (
      <td>
        <div className="w_170"></div>
      </td>
    );
  }, [
    item?.et_status,
    item?.complication,
    handleEmbryoChange,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
  ]);

  const DateOfFreezingFieldTd = useMemo(() => {
    return (
      <td>
        {/* <div className="w_170 custom_normal_input"> */}
        {/* <input
            type="date"
            onChange={(e) => {
              handleEmbryoChange(i, index, "date_of_freezing", e.target.value);
            }}
            value={item.date_of_freezing}
            placeholder="Date Of Freezing"
            disabled={
              disabledField("date_of_freezing") ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          /> */}

        {/* <Form.Item name={`date_of_freezing${i}${index}`} className="mb-1">
            <DatePicker
              placeholder="10/08/2023"
              value={dayjs(item?.date_of_freezing, "DD/MM/YYYY")}
              disabled={
                disabledField("date_of_freezing") ||
                item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                disableEmbryoGrade(item?.embryo_grade)
              }
              format={{
                format: "DD-MM-YYYY",
                type: "mask"
              }}
              onChange={(value) => {
                handleOccyteTableChange(
                  index,
                  i,
                  value ? moment(new Date(value)).format("YYYY-MM-DD") : null,
                  "date_of_freezing"
                );
              }}
            />
          </Form.Item> */}

        <div className="custom_select_date">
          <DatePicker
            placeholder="Date Of Freezing"
            value={
              item?.date_of_freezing
                ? dayjs(item?.date_of_freezing, "YYYY-MM-DD")
                : null
            }
            format={{
              format: "DD-MM-YYYY",
              type: "mask",
            }}
            onChange={(e) => {
              const fieldValue = e
                ? moment(new Date(e)).format("YYYY-MM-DD")
                : null;
              handleEmbryoChange(i, index, "date_of_freezing", fieldValue);
            }}
            disabled={
              // disabledField("date_of_freezing", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              checkEmbryoGradeValidation
            }
          />
        </div>
      </td>
    );
  }, [
    handleEmbryoChange,
    item.date_of_freezing,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
  ]);

  const VitrificationIdFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_250 custom_normal_input">
          <input
            onChange={(e) =>
              handleEmbryoChange(i, index, "vitrification_id", e.target.value)
            }
            value={item.vitrification_id || ""}
            placeholder="Vitrification ID"
            disabled={
              disabledField("vitrification_id", item, i, index) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item name={`vitrification_id${i}${index}`} className="mb-1">
            <Input
              placeholder="Vitrification ID"
              value={item?.vitrification_id}
              disabled={
                disabledField("vitrification_id", i, index) ||
                item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                disableEmbryoGrade(item?.embryo_grade)
              }
              onChange={(e) => {
                handleOccyteTableChange(
                  index,
                  i,
                  e.target.value || null,
                  "vitrification_id"
                );
              }}
            />
          </Form.Item> */}
        </div>
      </td>
    );
  }, [
    disabledField,
    handleEmbryoChange,
    item.vitrification_id,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
  ]);

  const StrawColorFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_170 ">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "straw_color", e.target.value)
          }
            disabled={
                disabledField("straw_color") ||
                item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                !item?.vitrification_id?.trim() ||
                disableEmbryoGrade(item?.embryo_grade)
            }
          >
            {strawColorOptions?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}
          {/* <div className="custom_select"> */}
          <div className="custom-normal-select">
            {/* <div className="ant-select"> */}
            <CustomCreatableSelect
              name="straw_color"
              value={item?.straw_color}
              options={strawColorOptions}
              className={`color_select ${
                item?.straw_color
                  ? getClassNameForValue(item?.straw_color.value)
                  : ""
              }`}
              onChange={(value) => {
                handleEmbryoChange(i, index, "straw_color", value);
              }}
              disabled={
                // disabledField("straw_color", item) ||
                handleBlastoScoreCondition ||
                handleFertCheckCondition ||
                handleVitrificationIdCondition ||
                // disableEmbryoGrade(item?.embryo_grade)
                checkEmbryoGradeValidation
              }
            />
            {/* </div> */}
          </div>

          {/* <Form.Item
            name={`straw_color${i}${index}`}
            className="custom_select mb-1"
          >*/}

          {/* <Select
            showSearch
            allowClear={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder="Select"
            disabled={
              disabledField("straw_color") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              !item?.vitrification_id?.trim() ||
              disableEmbryoGrade(item?.embryo_grade)
            }
            className="color_select"
            value={item?.straw_color}
            onChange={(value) => {
              //   handleOccyteTableChange(index, i, value || null, "straw_color");
              handleEmbryoChange(i, index, "straw_color", value || null);
            }}
            options={strawColorOptions}
          /> */}
          {/* </Form.Item>  */}
        </div>
      </td>
    );
  }, [
    item?.straw_color,
    handleEmbryoChange,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
    handleVitrificationIdCondition,
  ]);

  const StrawColorOtherFieldTd = useMemo(() => {
    return item?.straw_color?.value === "Other" ? (
      <td>
        <div className="w_200 custom_normal_input">
          <input
            value={item.straw_color_other || ""}
            placeholder="Device Color Other"
            onChange={(e) =>
              handleEmbryoChange(i, index, "straw_color_other", e.target.value)
            }
            className={`color_select ${
              item?.straw_color
                ? getClassNameForValue(item?.straw_color.value)
                : ""
            }`}
            disabled={
              disabledField("straw_color_other", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              handleVitrificationIdCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item
            // name={`egg${i}${index}`}
            name={`straw_color_other${i}${index}`}
            className="mb-1"
          >
            <Input
              disabled={
                disabledField("straw_color_other") ||
                item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                !item?.vitrification_id?.trim() ||
                disableEmbryoGrade(item?.embryo_grade)
              }
              placeholder="Device Color Other"
              // value={item?.package_amount}
              value={item?.straw_color_other}
              onChange={(e) => {
                handleOccyteTableChange(
                  index,
                  i,
                  e.target.value || "",
                  "straw_color_other"
                );
              }}
            />
          </Form.Item> */}
        </div>
      </td>
    ) : (
      <td>
        <div className="w_170"></div>
      </td>
    );
  }, [
    disabledField,
    item?.straw_color,
    handleEmbryoChange,
    item.straw_color_other,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
    handleVitrificationIdCondition,
  ]);

  const GobletColorFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_170 custom-normal-select">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "goblet_color", e.target.value)
            }
            placeholder="Select"
            disabled={
                disabledField("goblet_color") ||
                item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                !item?.vitrification_id?.trim() ||
                disableEmbryoGrade(item?.embryo_grade)
              }
          >
            {gobletColorOptions?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <CustomCreatableSelect
            name="goblet_color"
            value={item?.goblet_color}
            options={gobletColorOptions}
            onChange={(value) => {
              handleEmbryoChange(i, index, "goblet_color", value);
            }}
            className={`color_select ${
              item?.goblet_color
                ? getClassNameForValue(item?.goblet_color.value)
                : ""
            }`}
            disabled={
              // disabledField("goblet_color", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              handleVitrificationIdCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item
            name={`goblet_color${i}${index}`}
            className="custom_select mb-1"
          > */}
          {/* <Select
            showSearch
            allowClear={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={
              disabledField("goblet_color") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              !item?.vitrification_id?.trim() ||
              disableEmbryoGrade(item?.embryo_grade)
            }
            placeholder="Select"
            className="color_select"
            value={item?.goblet_color}
            onChange={(value) => {
              //   handleOccyteTableChange(index, i, value || null, "goblet_color");
              handleEmbryoChange(i, index, "goblet_color", value || null);
            }}
            options={gobletColorOptions}
          /> */}
          {/* </Form.Item> */}
        </div>
      </td>
    );
  }, [
    // disabledField,
    item?.goblet_color,
    handleEmbryoChange,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
    handleVitrificationIdCondition,
  ]);

  const GobletColorOtherFieldTd = useMemo(() => {
    return item?.goblet_color?.value === "Other" ? (
      <td>
        <div className="w_200 custom_normal_input">
          <input
            onChange={(e) =>
              handleEmbryoChange(i, index, "goblet_color_other", e.target.value)
            }
            value={item.goblet_color_other || ""}
            placeholder="Goblet Color Other"
            disabled={
              disabledField("goblet_color_other", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              handleVitrificationIdCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item
            // name={`egg${i}${index}`}
            name={`goblet_color_other${i}${index}`}
            className="mb-1"
          >
            <Input
              disabled={
                disabledField("goblet_color_other") ||
                item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                !item?.vitrification_id?.trim() ||
                disableEmbryoGrade(item?.embryo_grade)
              }
              placeholder="Goblet Color Other"
              value={item?.goblet_color_other}
              onChange={(e) => {
                handleOccyteTableChange(
                  index,
                  i,
                  e.target.value || "",
                  "goblet_color_other"
                );
              }}
            />
          </Form.Item> */}
        </div>
      </td>
    ) : (
      <td>
        <div className="w_170"></div>
      </td>
    );
  }, [
    disabledField,
    handleEmbryoChange,
    item.goblet_color_other,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
    handleVitrificationIdCondition,
  ]);

  const VitrifiedByFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_170 custom-normal-select">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "vitrified_by", e.target.value)
            }
            placeholder="Select"
            disabled={
              disabledField("vitrified_by") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              !item?.vitrification_id?.trim() ||
              disableEmbryoGrade(item?.embryo_grade)
            }
          >
            {vitrificationIdOptions?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <CustomCreatableSelect
            // isMulti
            name="vitrified_by"
            value={item?.vitrified_by}
            options={vitrificationIdOptions}
            onChange={(value) => {
              handleEmbryoChange(i, index, "vitrified_by", value);
            }}
            onCreate={(value) => {
              handleEmbryoChange(i, index, "vitrified_by", value);
            }}
            disabled={
              // disabledField("vitrified_by", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              handleVitrificationIdCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item
            name={`vitrified_by${i}${index}`}
            className="custom_select mb-1 custom_select_multiple"
          > */}

          {/* <Select
            mode="tags"
            className="custom_select mb-1 custom_select_multiple"
            allowClear={true}
            placeholder="Select"
            value={item?.vitrified_by}
            onChange={(value) => {
              //   handleOccyteTableChange(index, i, value || null, "vitrified_by");
              handleEmbryoChange(i, index, "vitrified_by", value || null);
            }}
            maxCount={1}
            options={vitrificationIdOptions}
            disabled={
              disabledField("vitrified_by") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              !item?.vitrification_id?.trim() ||
              disableEmbryoGrade(item?.embryo_grade)
            }
          /> */}
          {/* </Form.Item>  */}
        </div>
      </td>
    );
  }, [
    handleEmbryoChange,
    item?.vitrification_id,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
    handleVitrificationIdCondition,
  ]);

  const StatusFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_120 custom-normal-select">
          {/* <select
            onChange={(e) =>
              handleEmbryoChange(i, index, "status", e.target.value)
            }
            placeholder="Select"
            disabled={
              disabledField("status") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              !item?.vitrification_id?.trim() ||
              disableEmbryoGrade(item?.embryo_grade)
            }
          >
            {statusOptions?.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select> */}

          <CustomCreatableSelect
            name="status"
            value={item?.status}
            options={statusOptions}
            onChange={(value) => {
              handleEmbryoChange(i, index, "status", value);
            }}
            disabled={
              // disabledField("status", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              handleVitrificationIdCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item name={`status${i}${index}`} className="custom_select mb-1">*/}
          {/* <Select
            showSearch
            allowClear={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder="Select"
            disabled={
              disabledField("status") ||
              item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
              ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
              !item?.vitrification_id?.trim() ||
              disableEmbryoGrade(item?.embryo_grade)
            }
            value={item?.status}
            onChange={(value) => {
              //   handleOccyteTableChange(index, i, value || null, "status");
              handleEmbryoChange(i, index, "status", value || null);
            }}
            options={statusOptions}
          /> */}
          {/* </Form.Item> */}
        </div>
      </td>
    );
  }, [
    item?.status,
    handleEmbryoChange,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
    handleVitrificationIdCondition,
  ]);

  const WellNoFieldTd = useMemo(() => {
    return (
      <td>
        <div className="w_120 custom_normal_input">
          <input
            onChange={(e) =>
              handleEmbryoChange(i, index, "well_no", e.target.value)
            }
            value={item.well_no || ""}
            placeholder="Well No."
            disabled={
              // disabledField("well_no", item) ||
              handleBlastoScoreCondition ||
              handleFertCheckCondition ||
              handleVitrificationIdCondition ||
              // disableEmbryoGrade(item?.embryo_grade)
              checkEmbryoGradeValidation
            }
          />

          {/* <Form.Item name={`well_no${i}${index}`} className="mb-1">
            <Input
              disabled={
                disabledField("well_no") ||
                item?.blasto_score?.toLowerCase()?.trim() === "arrested" ||
                ["Degenerated", "Unfert", "Lysed"].includes(item?.fert_check) ||
                !item?.vitrification_id?.trim() ||
                disableEmbryoGrade(item?.embryo_grade)
              }
              placeholder="Well No."
              value={item?.well_no}
              onChange={(e) => {
                handleOccyteTableChange(
                  index,
                  i,
                  e.target.value || "",
                  "well_no"
                );
              }}
            />
          </Form.Item> */}
        </div>
      </td>
    );
  }, [
    item.well_no,
    // disabledField,
    handleEmbryoChange,
    handleFertCheckCondition,
    handleBlastoScoreCondition,
    checkEmbryoGradeValidation,
    handleVitrificationIdCondition,
  ]);

  const DeleteDataFieldTd = useMemo(() => {
    return (
      <td style={{ verticalAlign: "middle" }}>
        <div className="w_100 text-center">
          <Popconfirm
            title="Delete this data"
            description="Are you sure to delete this data?"
            onConfirm={() => {
              onDeleteEmbryoData(i, index);
            }}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button
              className="btn_transparent"
              // onClick={() => {
              //   onDeleteEmbryoData(index);
              // }}
            >
              <img src={TrashIcon} alt="TrashIcon" />
            </Button>
          </Popconfirm>
        </div>
      </td>
    );
  }, [i, index, onDeleteEmbryoData]);

  const renderRow = useMemo(() => {
    return (
      <tr
        key={index}
        className={
          ["1PN", "3PN"].includes(item?.fert_check?.value)
            ? "red_row_wrapper"
            : ""
        }
      >
        <div className="sticky_row">
          {OocytesFieldTd}
          {MaturationStageFieldTd}
        </div>
        {OocytesQualityFieldTd}
        {FertCheckFieldTd}
        {StageOfDevelopmentFieldTd}
        {EmbryoGradeFieldTd}
        {BlastoScoreFieldTd}
        {RatingFieldTd}
        {check_FreshET_in_planned_cycle ? ETStatusFieldTd : null}
        {check_FreshET_status_in_embryo ? ProviderFieldTd : null}
        {check_OTHER_provider_in_embryo ? ProviderOtherFieldTd : null}
        {check_FreshET_status_in_embryo ? IntroducerFieldTd : null}
        {check_OTHER_introducer_in_embryo ? IntroducerOtherFieldTd : null}
        {check_FreshET_status_in_embryo ? ComplicationFieldTd : null}
        {DateOfFreezingFieldTd}
        {VitrificationIdFieldTd}
        {StrawColorFieldTd}
        {check_OTHER_straw_color_in_embryo ? StrawColorOtherFieldTd : null}
        {GobletColorFieldTd}
        {check_OTHER_goblet_color_in_embryo ? GobletColorOtherFieldTd : null}
        {VitrifiedByFieldTd}
        {check_embryo_dev_pgt_in_embryo ? StatusFieldTd : null}
        {check_embryo_dev_incubator_in_embryo ? WellNoFieldTd : null}
        {(userType === 1 || selectedModule?.delete) && DeleteDataFieldTd}
      </tr>
    );
  }, [
    index,
    userType,
    item.fert_check,
    RatingFieldTd,
    StatusFieldTd,
    WellNoFieldTd,
    OocytesFieldTd,
    ETStatusFieldTd,
    ProviderFieldTd,
    FertCheckFieldTd,
    IntroducerFieldTd,
    DeleteDataFieldTd,
    StrawColorFieldTd,
    VitrifiedByFieldTd,
    BlastoScoreFieldTd,
    EmbryoGradeFieldTd,
    GobletColorFieldTd,
    ComplicationFieldTd,
    ProviderOtherFieldTd,
    DateOfFreezingFieldTd,
    OocytesQualityFieldTd,
    IntroducerOtherFieldTd,
    MaturationStageFieldTd,
    selectedModule?.delete,
    StrawColorOtherFieldTd,
    VitrificationIdFieldTd,
    GobletColorOtherFieldTd,
    StageOfDevelopmentFieldTd,
    check_FreshET_in_planned_cycle,
    check_FreshET_status_in_embryo,
    check_OTHER_provider_in_embryo,
    check_OTHER_introducer_in_embryo,
    check_OTHER_straw_color_in_embryo,
    check_OTHER_goblet_color_in_embryo,
    check_embryo_dev_pgt_in_embryo,
    check_embryo_dev_incubator_in_embryo,
  ]);

  return <>{renderRow}</>;
};
